import React from "react";
import {t} from "../../../shared-services/translate";
import InfoBadge from "./InfoBadge";
import NutritionalBadge from "./NutritionalBadge";
import currentTheme from "../../../react-themes/theme";

const theme = currentTheme();

export const GlutenFreeBadge = (props) => {
  return <NutritionalBadge
    image={"icons/gluten-free.svg"}
    className="gluten-free"
    color={theme.colors.farmy.green}
    {...props}
  >
    <span>{t("products.nutritional_tags.gluten_free")}</span>
  </NutritionalBadge>;
};

export const LactoseFreeBadge = (props) => {
  return <NutritionalBadge
    image={"icons/lactose-free.svg"}
    className="lactose-free"
    color={theme.colors.farmy.orange}
    {...props}
  >
    <span>{t("products.nutritional_tags.lactose_free")}</span>
  </NutritionalBadge>;
};

export const SulphitesBadge = (props) => {
  return <NutritionalBadge
    image={"icons/sulphites.svg"}
    className="sulphites"
    color={theme.colors.farmy.lightgrey}
    {...props}
  >
    <span>{t("products.nutritional_tags.sulphites")}</span>
  </NutritionalBadge>;
};

export const LocalBadge = (props) => {
  return <InfoBadge
    image={"icons/local.svg"}
    className="local"
    color={theme.colors.farmy.green}
    {...props}
  >
    <span>{t("products.info_tags.local")}</span>
  </InfoBadge>;
};

export const FarmyFamily = (props) => {
  return <InfoBadge
    image={"icons/farmy-family.svg"}
    className="farmy-family"
    color={theme.colors.farmy.green}
    {...props}
  >
    <span>{t("farmy_family.farmy_family")}</span>
  </InfoBadge>;
};

export const SpecialOffer = (props) => {
  return <InfoBadge
    image={"icons/special-offer.svg"}
    className="special-offer"
    color={theme.colors.farmy.orange}
    {...props}
  >
    <span>{t("products.info_tags.special_offer")}</span>
  </InfoBadge>;
};

export const Exclusive = (props) => {
  return <InfoBadge
    image={"icons/exclusive.svg"}
    className="exclusive"
    color={theme.colors.farmy.orange}
    {...props}
  >
    <span>{t("products.info_tags.exclusive")}</span>
  </InfoBadge>;
};
